import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
    title: {
        color: theme.palette.blue_300.main
    }
}))
